<template>
  <QaPageShell :title="$t('_QASettings')" :loading="false" :error="null">
    <!-- Q10 — แบนเนอร์ "เก็บไว้ในเครื่องคุณเท่านั้น (โหมดสาธิต)" ถูกถอดออกแล้ว
         หลัง Q9/Q10 **ไม่มีแท็บไหนเขียน localStorage อีกเลย**: 5 แท็บแรกบันทึกลง cc.QaSettings จริง ·
         taxonomy อ่านอย่างเดียวจาก sy.Dbsettings · audit เป็นแถวตัวอย่างที่ติดป้ายไว้ในตัวมันเอง
         ⚠️ flag `isLive` ยังอยู่และยังมีเทสตรึง — เก็บไว้เป็นทะเบียนว่าแท็บไหนเขียนฐานจริง
            (ถ้ามีแท็บใหม่ที่ยังไม่ต่อของจริง ให้ติดป้ายในแท็บนั้น ไม่ใช่เอาแบนเนอร์รวมกลับมา) -->

    <v-card class="qa-card mt-3" variant="flat">
      <v-tabs v-model="tab" color="primary" show-arrows density="comfortable">
        <v-tab v-for="item in tabs" :key="item.value" :value="item.value">
          <v-icon size="17" class="mr-2">{{ item.icon }}</v-icon>
          {{ item.label }}
        </v-tab>
      </v-tabs>
      <v-divider />

      <div class="pa-4">
        <div class="mb-4">
          <div class="text-subtitle-1">{{ activeTab.label }}</div>
          <div class="text-body-2 text-medium-emphasis">{{ activeTab.description }}</div>
        </div>

        <v-window v-model="tab">
          <v-window-item value="rubric"><QaRubricBuilder @saved="notify" /></v-window-item>
          <v-window-item value="policy"><QaPolicySettings @saved="notify" /></v-window-item>
          <v-window-item value="evaluator"><QaEvaluatorSettings @saved="notify" /></v-window-item>
          <v-window-item value="summary"><QaSummarySettings @saved="notify" /></v-window-item>
          <v-window-item value="recommend"><QaRecommendSettings @saved="notify" /></v-window-item>
          <v-window-item value="nba"><QaNextBestActionSettings @saved="notify" /></v-window-item>
          <v-window-item value="prechat-routing"><QaPrechatRoutingSettings @saved="notify" /></v-window-item>
          <v-window-item value="feedback-reasons"><QaFeedbackReasonSettings @saved="notify" /></v-window-item>
          <v-window-item value="sentiment"><QaSentimentSettings @saved="notify" /></v-window-item>
          <v-window-item value="voice-stream"><QaVoiceStreamSettings @saved="notify" /></v-window-item>
          <v-window-item value="pipeline"><QaPipelineSettings @saved="notify" /></v-window-item>
          <v-window-item value="masking"><QaMaskingSettings @saved="notify" /></v-window-item>
          <v-window-item value="taxonomy"><QaTaxonomySettings @saved="notify" /></v-window-item>
          <v-window-item value="audit"><QaAuditLog /></v-window-item>
        </v-window>
      </div>
    </v-card>

    <v-snackbar v-model="snackbar" :color="snackbarColor" location="bottom right" timeout="3200">
      {{ snackbarText }}
    </v-snackbar>
  </QaPageShell>
</template>

<script>
/**
 * QA Settings — กลุ่ม MVP 8 กลุ่มตาม QA-Settings-Design.html
 * (กลุ่ม Sentiment / Investigation / Calibration / Notification เป็น Phase 2)
 */
import QaPageShell from '@/components/QAConsole/QaPageShell.vue';
import QaRubricBuilder from '@/components/QAConsole/settings/QaRubricBuilder.vue';
import QaPolicySettings from '@/components/QAConsole/settings/QaPolicySettings.vue';
import QaEvaluatorSettings from '@/components/QAConsole/settings/QaEvaluatorSettings.vue';
import QaSummarySettings from '@/components/QAConsole/settings/QaSummarySettings.vue';
import QaRecommendSettings from '@/components/QAConsole/settings/QaRecommendSettings.vue';
import QaNextBestActionSettings from '@/components/QAConsole/settings/QaNextBestActionSettings.vue';
import QaPrechatRoutingSettings from '@/components/QAConsole/settings/QaPrechatRoutingSettings.vue';
import QaFeedbackReasonSettings from '@/components/QAConsole/settings/QaFeedbackReasonSettings.vue';
import QaSentimentSettings from '@/components/QAConsole/settings/QaSentimentSettings.vue';
import QaVoiceStreamSettings from '@/components/QAConsole/settings/QaVoiceStreamSettings.vue';
import QaPipelineSettings from '@/components/QAConsole/settings/QaPipelineSettings.vue';
import QaMaskingSettings from '@/components/QAConsole/settings/QaMaskingSettings.vue';
import QaTaxonomySettings from '@/components/QAConsole/settings/QaTaxonomySettings.vue';
import QaAuditLog from '@/components/QAConsole/settings/QaAuditLog.vue';

export default {
  name: 'QASettings',
  components: { QaPageShell, QaRubricBuilder, QaPolicySettings, QaEvaluatorSettings, QaSummarySettings, QaRecommendSettings, QaNextBestActionSettings, QaPipelineSettings, QaMaskingSettings, QaTaxonomySettings, QaAuditLog, QaPrechatRoutingSettings, QaFeedbackReasonSettings, QaSentimentSettings, QaVoiceStreamSettings },
  data() {
    return {
      tab: 'rubric',
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
    };
  },
  computed: {
    /**
     * ⚠️ ต้องเป็น computed ไม่ใช่ data — ถ้าอยู่ใน data() ค่าจะถูกคำนวณครั้งเดียวตอน mount
     *    แล้วกดสลับภาษามุมขวาบนหน้านี้จะไม่เปลี่ยนจนกว่าจะ remount
     *    (this.$t ใน data() ไม่ reactive ต่อ locale)
     *
     * isLive = บันทึกลงฐานข้อมูลจริง ไม่ใช่ localStorage (Q9 ทำ 5 แท็บให้คะแนนเป็นของจริงแล้ว)
     */
    tabs() {
      return [
        { value: 'rubric', label: this.$t('qaTabRubric'), icon: 'mdi-clipboard-check-outline', isLive: true, description: this.$t('qaTabRubricDesc') },
        { value: 'policy', label: this.$t('qaTabPolicy'), icon: 'mdi-gavel', isLive: true, description: this.$t('qaTabPolicyDesc') },
        { value: 'evaluator', label: this.$t('qaTabEvaluator'), icon: 'mdi-robot-outline', isLive: true, description: this.$t('qaTabEvaluatorDesc') },
        { value: 'summary', label: this.$t('qaTabSummary'), icon: 'mdi-text-box-outline', isLive: true, description: this.$t('qaTabSummaryDesc') },
        { value: 'recommend', label: this.$t('qaTabRecommend'), icon: 'mdi-lightbulb-on-outline', isLive: true, description: this.$t('qaTabRecommendDesc') },
        { value: 'nba', label: this.$t('qaTabNba'), icon: 'mdi-compass-outline', isLive: true, description: this.$t('qaTabNbaDesc') },
        { value: 'prechat-routing', label: this.$t('qaTabPrechat'), icon: 'mdi-call-split', isLive: true, description: this.$t('qaTabPrechatDesc') },
        { value: 'feedback-reasons', label: this.$t('qaTabFeedbackReasons'), icon: 'mdi-comment-alert-outline', isLive: true, description: this.$t('qaTabFeedbackReasonsDesc') },
        { value: 'sentiment', label: this.$t('qaTabSentiment'), icon: 'mdi-emoticon-outline', isLive: true, description: this.$t('qaTabSentimentDesc') },
        { value: 'voice-stream', label: this.$t('qaTabVoiceStream'), icon: 'mdi-phone-in-talk-outline', isLive: true, description: this.$t('qaTabVoiceStreamDesc') },
        { value: 'pipeline', label: this.$t('qaTabPipeline'), icon: 'mdi-pipe', isLive: true, description: this.$t('qaTabPipelineDesc') },
        { value: 'masking', label: this.$t('qaTabMasking'), icon: 'mdi-shield-lock-outline', isLive: true, description: this.$t('qaTabMaskingDesc') },
        // ⚠️ ไม่มี isLive เพราะสองแท็บนี้ **อ่านอย่างเดียว** (ไม่ได้เขียนอะไรเลย)
        { value: 'taxonomy', label: this.$t('qaTabTaxonomy'), icon: 'mdi-shape-outline', description: this.$t('qaTabTaxonomyDesc') },
        { value: 'audit', label: this.$t('qaTabAudit'), icon: 'mdi-history', description: this.$t('qaTabAuditDesc') },
      ];
    },

    activeTab() {
      return this.tabs.find((t) => t.value === this.tab) || this.tabs[0];
    },
  },
  methods: {
    notify(result) {
      this.snackbarText = result.message;
      this.snackbarColor = result.ok ? 'success' : 'error';
      this.snackbar = true;
    },
  },
};
</script>
